<script setup lang="ts">
import { AppSelect } from '@shared/ui/selects'

import {
  useSelectPauseDuration,
} from '../../../../model/additional-info/support/info-pause-subscription/select-pause-duration.hook'

defineOptions({
  name: 'SelectPauseDuration',
})

const {
  placeholder,
  model,
  options,
} = useSelectPauseDuration()
</script>

<template>
  <AppSelect
    v-model="model"
    :options="options"
    :placeholder="placeholder"
  />
</template>
